import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const MapLegendElement = ({ text, side }) => {
    return (
        <div
            className={cn("flex items-center gap-2 justify-end mb-2", {
                "flex-row-reverse": side === "left",
            })}
        >
            <div className="text-cm-p-text-primary text-sm/[23px]">
                <TranslatedText>{text}</TranslatedText>
            </div>
            <div
                className={cn("w-5 h-5 mr-1 rounded-[2px]", {
                    "w-4 h-4": side === "left",
                    "bg-cm-p-area-step-four": text === "prime",
                    "bg-cm-p-area-step-three": text === "stable",
                    "bg-cm-p-area-step-two": text === "average",
                    "bg-cm-p-area-step-one": text === "weak",
                })}
            />
        </div>
    );
};
